export const resetView = (api, position, target) => {
    api.setCameraLookAt(position, target, 2);
};
